module.exports = "/_next/static/images/bg-info-extend-3-7a59ca8e.png";